import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { EventStatus, WebhookEvent } from '../shared/webhook-event.model';
import { WebhookEventService } from '../shared/webhook-event.service';
import { ErrorHandlerService } from '../../shared/services/error-handler.service';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../../shared/services/loader.service';
import { ClipboardService } from '../../shared/services/clipboard.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { JsonEditorService } from '../../shared/services/json-editor.service';
import { NavigationLinkService } from '../../shared/services/navigation-link.service';

@Component({
  selector: 'app-webhook-events-details',
  templateUrl: './webhook-events-details.component.html',
  styleUrls: ['./webhook-events-details.component.scss']
})
export class WebhookEventsDetailsComponent {

  EventStatus = EventStatus;
  event: WebhookEvent;
  private _eventId: string;

  maxAutomaticTries = 3;

  @Input()
  get eventId() {
    return this._eventId;
  }

  set eventId(eventId: string) {
    this._eventId = eventId;
    this.event    = undefined
    if (eventId) {
      this.refreshDetails();
    }
  }

  @Output()
  private onBackSelection = new EventEmitter<void>();

  public actionInProgress = false;

  constructor(
    private webhookEventService: WebhookEventService,
    private errorHandler: ErrorHandlerService,
    private loader: LoaderService,
    private clipboard: ClipboardService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private jsonEditorService: JsonEditorService,
    public link: NavigationLinkService,
  ) {
  }

  public onBackSelected(): void {
    this.onBackSelection.next();
  }

  public openJsonInEditor(json: any, stringify: boolean = true): void {
    this.loader.startLoad();
    this.jsonEditorService.createJsonEditorDoc(
      `webhooks-events.details.contextual-data-${this.event.id}`,
      stringify ? JSON.stringify(json) : json
    )
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe(result => {
        if (result.ok) {
          window.open(`http://jsoneditoronline.org/?id=${result.id}`, '_blank');
        }
      });
  }

  copyJson(json: any, stringify: boolean = true): void {
    if (this.clipboard.copy(stringify ? JSON.stringify(json) : json)) {
      this.toastr.success(this.translate.instant('copy.success'));
    } else {
      this.toastr.error(this.translate.instant('copy.error'));
    }
  }

  retrySendingEvent(eventId: string): void {
    this.loader.startLoad();
    this.actionInProgress = true;
    this.webhookEventService.retrySendingEvent(eventId).pipe(finalize(() => {
      this.actionInProgress = false;
      this.loader.stopLoad();
    })).subscribe(event => {
      this.event = event;
      this.toastr.success(this.translate.instant('webhooks-events.details.retry-send.success'))
    }, e => this.errorHandler.handleHttpError(e, 'webhooks-events.details.retry-send.error'));
  }

  refreshDetails() {
    this.webhookEventService.getEventById(this.eventId).subscribe(event => {
        this.event = event;
      }, error => this.errorHandler.handleHttpError(error, 'webhooks-events.details.errors.fetch-event-by-id')
    );
  }
}
